import styled from "styled-components";
import { s } from "@shared/styles";

const Empty = styled.p`
  color: ${s("textTertiary")};
  user-select: none;
`;

export default Empty;
